<template>
  <div id="adminproducts">
    <div class="pa-2">
      <v-row justify="space-between">
        <v-col>
          <Products />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script lang="ts">
import Products from "@/components/admin-components/global/Products.vue";
export default {
  name: "AdminProducts",
  components: { Products },
  data: () => ({}),
};
</script>
